import applicationStore from "@app/state/store/application";
import session from "@app/state/store/session";
import notify from "@app/components/notify";

import articleGalaxyService from "@app/services/article-galaxy";

const DISABLED_STATUS = ["failed", "ordering", "waiting_download"];

function isOrderEnabled() {
    return applicationStore.enableArticleGalaxy && session.can("article.purchase");
}

function canOrder(article) {
    if (!article) {
        return false;
    }

    return (
        !article.file &&
        !DISABLED_STATUS.includes(article.fullTextOrder?.status) &&
        !articleGalaxyService.loading
    );
}

async function order(article) {
    if (articleGalaxyService.loading) {
        return;
    }

    try {
        article.fullTextOrder = { status: "ordering" };
        const result = await articleGalaxyService.placeOrder(article.project, article._id);

        if (result.success) {
            if (result.reused) {
                notify.success("Reusing previous order. Full text article attached");
            } else {
                notify.success("Order placed. Waiting for download availability...");
            }
        } else {
            notify.error(result.message || "Failed to place order");
        }
    } catch (error) {
        notify.error(error.response?.data?.error || "Failed to place order");
    }
}

export default {
    isOrderEnabled,
    canOrder,
    order,
};
